<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Riwayat Pembayaran</h4>
    </div>
    <div class="card-body">
      <!-- <button class="btn btn-primary btn-sm col-md">
        <span>Riwayat Pembayaran</span>
      </button>
      <div class="col-md-12 mt-5 mb-5"></div> -->
      <ul v-for="(ph, index) in paymentHistory" :key="index">
        <li>
          <div class="font-weight-bold badge badge-soft-success mb-1">{{ ph.title }}</div>
          <br />

          <div>{{ ph.text }}</div>
          <br />
          <div><b>Hari/Tanggal</b> : {{ moment(ph.createdAt).locale("id").format(`dddd D-MM-Y`) }}</div>
          <div><b>Waktu</b> : {{ ph.timeAt }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["paymentHistory"],
};
</script>



<style scoped>
.fs-13 {
  font-size: 13px;
}
.h4-icon {
  font-size: 20px;
}
.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.verti-timeline .event-list {
  position: relative;
  padding: 0 0 40px 28px;
}

.list-unstyled {
  list-style: none;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}

.media {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.me-3 {
  margin-right: 1rem !important;
}

.media-body {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.verti-timeline .event-list.active .event-timeline-dot {
  color: #556ee6;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}
</style>